import { fetchWrapper, handleResponse, hcUrl, buildOpts } from 'services/RequestService/helpers';

export const getStreakOffers = async () => {
  const response = await fetchWrapper(hcUrl('/user_rewards'), buildOpts());
  return handleResponse(response);
};
